module.exports = __webpack_public_path__ + "static/media/introscr.ced7bb5d.jpg";